import { bumpPopulationVersion } from './populationVersion'

/**
 * Mémoires de la transparence salariale gardées le temps de la page (`cachedGet.js`, `useEmployeeBiais.js`,
 * `useCriteriaAnalysis.js`) : salaires, écarts, listes de salariés. Elles ne doivent pas survivre à l'utilisateur
 * qui les a lues : la déconnexion et la connexion (`redux/authentication.js`) les vident.
 *
 * Chaque mémoire s'inscrit ici à son chargement : ce fichier n'importe aucun écran, l'authentification peut le
 * charger sans tirer tout le module.
 */
const clearers = new Set()

export const registerPayTransparencyMemory = (clear) => {
    clearers.add(clear)
}

/**
 * Vide toutes les mémoires inscrites. La version de la population change aussi : une réponse encore en route,
 * demandée par l'utilisateur précédent, se range sous une clé que plus personne ne lit.
 */
export const resetPayTransparencyMemory = () => {
    clearers.forEach((clear) => clear())
    bumpPopulationVersion()
}
